const advancedSearchFormStyle = theme => ({
	root: {
		'& .MuiTextField-root': {
			marginTop: theme.spacing(2),
		},
	},

	datePickerField: {
		marginBottom: theme.spacing(0),
		width: '49%',
	},

	dateOfDocuemntField: {
		width: '100%',
	},
})


export {advancedSearchFormStyle}